import React from 'react';

import Grid, { allowedLayouts } from 'foundations/Grids/Grid';
import GridBlock from 'foundations/Grids/GridBlock';

export const gridColors = {
  'margin'  : '#f2f4f8',
  'sidenav' : '#c2c2c6',
  'red'     : '#f1cfd3',
  'extraNav': '#d9dbdf',
};

const styles = {
  left : { background: gridColors['sidenav'] },
  right: { background: gridColors['margin'] },
  main : { background: gridColors['red'] },
  extra: { background: gridColors['extraNav'] },
};

const FullWidthContainer = index => (
  <Grid layout={allowedLayouts.side_main} key={`inner-grid-${index}`}>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
  </Grid>
);

const VerticalSectionMarkerMainContainer = index => (
  <Grid layout={allowedLayouts.vsm_main} key={`inner-grid-${index}`}>
    <GridBlock customStyles={styles.left} modifier={'VerticalSectionMarker'}>&nbsp;</GridBlock>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
  </Grid>
);

const SideNavMainContainer = index => (
  <Grid layout={allowedLayouts.side_main} key={`inner-grid-${index}`}>
      <GridBlock customStyles={styles.left} modifier={'SideNav'}>&nbsp;</GridBlock>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
  </Grid>
);

const SideNavSecLevelMaincontainer = index => (
  <Grid layout={allowedLayouts.side_second_main} key={`inner-grid-${index}`}>
      <GridBlock customStyles={styles.left} modifier={'SideNav'}>&nbsp;</GridBlock>
      <GridBlock customStyles={styles.extra} modifier={'SecondLevel'}>&nbsp;
    </GridBlock>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
  </Grid>
);

const StepTrackerMainContainer = index => (
  <Grid layout={allowedLayouts.step_main} key={`inner-grid-${index}`}>
      <GridBlock customStyles={styles.left} modifier={'StepTrackerContainer'}>&nbsp;</GridBlock>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
  </Grid>
);

const StepTrackerLeftContainerMainContainer = index => (
  <Grid layout={allowedLayouts.step_left_main} key={`inner-grid-${index}`}>
      <GridBlock customStyles={styles.left} modifier={'StepTrackerContainer'}>&nbsp;</GridBlock>
      <GridBlock customStyles={styles.extra} modifier={'LeftSection'}>&nbsp;</GridBlock>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
  </Grid>
);

const StepTrackerLeftContainerMainContainerRightContainer = index => (
  <Grid layout={allowedLayouts.step_left_main_right} key={`inner-grid-${index}`}>
      <GridBlock customStyles={styles.left} modifier={'StepTrackerContainer'}>&nbsp;</GridBlock>
      <GridBlock customStyles={styles.extra} modifier={'LeftSection'}>&nbsp;</GridBlock>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
    <GridBlock
      customStyles={styles.extra}
      classes={'full-height'}
      modifier={'RightSection'}
    >
      &nbsp;
    </GridBlock>
  </Grid>
);

const StepTrackerMapMainContainer = index => (
  <Grid layout={allowedLayouts.step_map_main} key={`inner-grid-${index}`}>
      <GridBlock customStyles={styles.left} modifier={'StepTrackerContainer'}>&nbsp;</GridBlock>
      <GridBlock customStyles={styles.extra} modifier={'MapSection'}>&nbsp;</GridBlock>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
  </Grid>
);

const StepTrackerMainContainerRightContainer = index => (
  <Grid layout={allowedLayouts.step_main_right} key={`inner-grid-${index}`}>
      <GridBlock customStyles={styles.left} modifier={'StepTrackerContainer'}>&nbsp;</GridBlock>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
      <GridBlock customStyles={styles.extra} modifier={'RightSection'}>&nbsp;</GridBlock>
  </Grid>
);

const LeftContainerMainContainerRightContainer = index => (
  <Grid layout={allowedLayouts.left_main_right} key={`inner-grid-${index}`}>
      <GridBlock customStyles={styles.extra} modifier={'LeftSection'}>&nbsp;</GridBlock>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
      <GridBlock customStyles={styles.extra} modifier={'RightSection'}>&nbsp;</GridBlock>
  </Grid>
);

const LeftContainerMainContainer = index => (
  <Grid layout={allowedLayouts.left_main} key={`inner-grid-${index}`}>
      <GridBlock customStyles={styles.left} modifier={'LeftSection'}>&nbsp;</GridBlock>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
  </Grid>
);

const RightContainerMainContainer = index => (
  <Grid layout={allowedLayouts.main_right} key={`inner-grid-${index}`}>
    <GridBlock
      customStyles={styles.main}
      classes={'full-height'}
      modifier={'MainContainer'}
    >
      &nbsp;
    </GridBlock>
      <GridBlock customStyles={styles.left} modifier={'RightSection'}>&nbsp;
    </GridBlock>
  </Grid>
);

/* eslint-disable react/display-name */
export const gridLayouts = {
  FullWidthContainer: () => <FullWidthContainer />,
  VerticalSectionMarkerMainContainer: () => <VerticalSectionMarkerMainContainer />,
  SideNavMainContainer: () => <SideNavMainContainer />,
  SideNavSecLevelMaincontainer: () => <SideNavSecLevelMaincontainer />,
  StepTrackerMainContainer: () => <StepTrackerMainContainer />,
  StepTrackerLeftContainerMainContainer: () => <StepTrackerLeftContainerMainContainer />,
  StepTrackerLeftContainerMainContainerRightContainer: () => <StepTrackerLeftContainerMainContainerRightContainer />,
  StepTrackerMapMainContainer: () => <StepTrackerMapMainContainer />,
  StepTrackerMainContainerRightContainer: () => <StepTrackerMainContainerRightContainer />,
  LeftContainerMainContainerRightContainer: () => <LeftContainerMainContainerRightContainer />,
  LeftContainerMainContainer: () => <LeftContainerMainContainer />,
  RightContainerMainContainer: () => <RightContainerMainContainer />,
};



// WEBPACK FOOTER //
// ./src/containers/foundations/Grids/constants/gridLayouts.js